import React from 'react';

const ArticlesListPage = React.lazy(() => import('@apps/Articles/pages/ArticlesListPage'));
const ArticleEditPage = React.lazy(() => import('@apps/Articles/pages/ArticleEditPage'));
const ArticleOnePage = React.lazy(() => import('@apps/Articles/pages/ArticleOnePage'));
const ArticleAddPage = React.lazy(() => import('@apps/Articles/pages/ArticleAddPage'));

import { IPohodnikRouterItem } from '.';

const articlesRoutes: Array<IPohodnikRouterItem> = [
  {
    path: '/articles/new',
    component: () => <ArticleAddPage />,
    title: 'Добавление статьи',
    protected: true,
  },
  {
    path: '/articles/:id/edit',
    component: ({
      match: {
        params: { id },
      },
    }) => <ArticleEditPage id={id} />,
    protected: true,
    title: 'Редактирование статьи',
  },
  {
    path: '/articles/:id',
    component: ({
      match: {
        params: { id },
      },
    }) => <ArticleOnePage id={id} />,
    title: 'Статья',
  },
  {
    path: '/articles',
    component: () => <ArticlesListPage />,
    protected: true,
    title: 'Статьи',
  },
];

export default articlesRoutes;
